'use client';
import formatRepliersImageSource from '@th/shared/src/helpers/formatRepliersImageSource';
import * as React from 'react';
import ListingSpaceSummary from '../listingDetails/ListingSpaceSummary';
import { THUMB_IMAGE_RESOLUTION } from '@th/frontend-shared/src/constants/images';
import useIsListingBlurred from '../../hooks/useIsListingBlurred';
import replaceCharactersWithX from '@th/shared/src/helpers/sanitization/replaceCharactersWithX';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';

type Props = {
  listing: SimpleListing;
};

export default function ListingResult({ listing }: Props) {
  const isDetailsBlurred = useIsListingBlurred(listing);

  const listingImageUri =
    listing.images.length > 0
      ? formatRepliersImageSource(listing.images[0], 'small').uri
      : '/images/imagePlaceholder.png';

  return (
    <div className="flex flex-row justify-start items-center">
      <div className="w-1/4 pr-4">
        <img
          src={listingImageUri}
          alt={`Preview image for ${listing.address.formattedAddressShortOneLiner()}`}
          className="object-cover aspect-3/2"
          key={`${listing.id}-image`}
        />
      </div>
      <div className="flex flex-col">
        <div className="font-semibold">
          {isDetailsBlurred
            ? '(Address display requires sign-in)'
            : listing.address.formattedAddressShortOneLiner()}
        </div>
        <div>
          <ListingSpaceSummary listing={listing} isBlurred={isDetailsBlurred} />
        </div>
        <div className="text-secondaryText">
          <span>
            {isDetailsBlurred
              ? replaceCharactersWithX(listing.displayPrice())
              : listing.displayPrice()}
          </span>{' '}
          <span>({listing.lastStatusText()})</span>
        </div>
      </div>
    </div>
  );
}
